import React, { FC, memo } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

interface IRecaptchaProviderProps {}

const RECAPTCHA_SITE_KEY = window.__RECAPTCHA_SITE_KEY__ || __RECAPTCHA_SITE_KEY__;

export const RecaptchaProvider: FC<IRecaptchaProviderProps> = memo(({ children }) => {
  return <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>{children}</GoogleReCaptchaProvider>;
});
